import { Badge } from './badge';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from './tooltip';
import { cn } from '../../utils';

export interface TooltipBadgeItem {
  value: number | string;
  tooltip: string;
  className: string;
}

export function TooltipBadgeGroup({
  badges,
  className,
}: {
  badges: TooltipBadgeItem[];
  className?: string;
}) {
  return (
    <div
      className={cn(
        'inline-flex gap-0.5 bg-white rounded-sm p-0.5',
        className,
      )}
    >
      {badges.map((badge) => (
        <Tooltip key={badge.tooltip}>
          <TooltipTrigger asChild>
            <Badge
              className={cn(
                'min-w-7 text-center text-xs rounded-sm',
                badge.className,
              )}
            >
              {badge.value}
            </Badge>
          </TooltipTrigger>
          <TooltipContent>{badge.tooltip}</TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}
